import { useTheme } from 'app/shopify';
import { isDarkColor } from 'app/utils/helpers';
import { StatusBar } from 'expo-status-bar';
import { Platform } from 'react-native';
import { canChangeAppTheme } from './app-theme-policy';

export function CustomStatusBar() {
  const theme = useTheme();

  // Keep system icons readable against the header when the development theme changes.
  if (Platform.OS !== 'android' && !canChangeAppTheme()) return null;
  const isDark = isDarkColor(theme.colors['white-label.header.bg']);
  return <StatusBar style={isDark ? 'light' : 'dark'} />;
}
